var _g, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueOpenCollapseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1123_7705)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 27,
    height: 27,
    rx: 13.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.18742 12.6121L12.9987 16.4233C13.0761 16.5008 13.158 16.5564 13.2446 16.5901C13.3311 16.6238 13.4234 16.6406 13.5215 16.6406C13.6196 16.6406 13.7119 16.6238 13.7984 16.5901C13.8849 16.5564 13.9669 16.5008 14.0443 16.4233L17.8687 12.599C18.0135 12.4541 18.0859 12.2777 18.0859 12.0696C18.0859 11.8615 18.0135 11.685 17.8687 11.5402C17.7238 11.3953 17.5452 11.3251 17.3327 11.3295C17.1202 11.3339 16.9416 11.4085 16.7967 11.5533L13.5215 14.8286L10.2331 11.5402C10.0882 11.3953 9.91396 11.3229 9.71025 11.3229C9.50655 11.3229 9.33227 11.3953 9.18742 11.5402C9.04258 11.685 8.97016 11.8637 8.97016 12.0762C8.97016 12.2886 9.04258 12.4673 9.18742 12.6121Z",
    fill: "#3772FF"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.516232,
    y: 0.516232,
    width: 25.9677,
    height: 25.9677,
    rx: 12.9838,
    stroke: "#3772FF",
    strokeWidth: 1.03233
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1123_7705"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 27,
    height: 27,
    rx: 13.5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueOpenCollapseIcon);
export default __webpack_public_path__ + "static/media/blueOpenCollapseIcon.badb1121.svg";
export { ForwardRef as ReactComponent };